module.exports = __webpack_public_path__ + "img/student_7.146b45a2.png";